import { CloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledCardWrapper = styled(Flex)`
  background: ${(props) => props.theme.colors.accentBlue6};
  border-radius: ${themeSpace(5)};
  justify-content: center;
  position: relative;
  min-height: 592px;
  overflow: hidden;
`;

export const StyledContentWrapper = styled(Flex)`
  position: absolute;
  bottom: ${themeSpace(10)};
  flex-direction: column;
  align-items: center;
  padding: 0 90px;
  ${themeMediaQuery('below_sm')} {
    padding: 0 ${themeSpace(5)};
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  align-items: center;
  .text-pairing-title {
    font-weight: 700;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  position: absolute;
  left: 0;
  width: 100%;
  ${themeMediaQuery('sm')} {
    bottom: 25%;
  }
  ${themeMediaQuery('md')} {
    bottom: unset;
  }
  ${themeMediaQuery('lg')} {
    bottom: 32%;
    height: auto;
    width: 98%;
  }
  ${themeMediaQuery('xl')} {
    height: auto;
    width: 96%;
    bottom: 38%;
  }
`;
